import { IconButton } from "@mui/material";
import { StyledTableCell } from "../Styled";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";


export const RenderActionsCell = ({ row, allowEdit, allowDelete, handleEditMenu, handleDeleteMenu }) => {

    if (allowEdit || allowDelete) {
        return (
            <StyledTableCell size="small">
                <>
                    {allowEdit && (
                        <IconButton
                            size="small"
                            aria-label="edit"
                            onClick={(e) => handleEditMenu(e, row)}
                            disabled={
                                Object.values(row)[0]?.rowOptions?.hasOwnProperty("allowEdit") &&
                                !Object.values(row)[0]?.rowOptions?.allowEdit
                            }
                        >
                            <EditOutlinedIcon fontSize="small" />
                        </IconButton>
                    )}

                    {allowDelete && (
                        <IconButton
                            size="small"
                            aria-label="delete"
                            onClick={() => handleDeleteMenu(row)}
                            disabled={
                                Object.values(row)[0]?.rowOptions?.hasOwnProperty("allowDelete") &&
                                !Object.values(row)[0]?.rowOptions?.allowDelete
                            }
                        >
                            <DeleteOutlineOutlinedIcon fontSize="small" />
                        </IconButton>
                    )}
                </>
            </StyledTableCell>
        );
    }

    return null;
};